import { render, staticRenderFns } from "./customQueryItem.vue?vue&type=template&id=af9298fa&"
import script from "./customQueryItem.vue?vue&type=script&lang=js&"
export * from "./customQueryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/query/customQueryItem.vue"
export default component.exports